import React, { type JSX, type DetailedHTMLProps, type DetailsHTMLAttributes } from "react";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

import { SupText } from "@repo/core-ui";

interface NavItemProps extends DetailedHTMLProps<DetailsHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  href?: string;
  active?: boolean;
  icon: JSX.Element;
  title: string;
  disabled?: boolean;
  useATag?: boolean;
}

export function NavItem({ useATag = false, active, href, icon, title, disabled = false, ...props }: NavItemProps) {
  if (href) {
    const content = (
      <>
        {icon}
        <SupText as="span" variant="subtitle2" family="mono">
          {title}
        </SupText>
      </>
    );
    return useATag ? (
      <Link
        href={href}
        className={twMerge(
          "flex cursor-pointer flex-col items-center border-0.5 border-t-4 border-transparent pb-2 pt-1 text-neutral-900",
          active && "border-primary-500 bg-primary-300 font-bold",
          props.className
        )}
      >
        {content}
      </Link>
    ) : (
      <a
        href={href}
        className={twMerge(
          "flex cursor-pointer flex-col items-center border-0.5 border-t-4 border-transparent pb-2 pt-1 text-neutral-900",
          active && "border-primary-500 bg-primary-300 font-bold",
          props.className
        )}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      {...props}
      disabled={disabled}
      className={twMerge(
        "flex cursor-pointer flex-col items-center border-0.5 border-t-4 border-transparent pb-2 pt-1 text-neutral-900",
        active && "border-primary-500 bg-primary-300 font-bold",
        disabled && "opacity-70",
        props.className
      )}
    >
      {icon}
      <SupText as="span" variant="subtitle2" family="mono">
        {title}
      </SupText>
    </button>
  );
}
